import { PlainButton } from "@jugl-web/ui-kit";
import { cx, useClipboard, useTranslations } from "@jugl-web/utils";
import React, { useState } from "react";
import { collapsedIconButtonClassName } from "@web-src/modules/client-support/pages/ClientSupportPage/consts";
import { CRMAccountCard } from "../../../../components/CRMAccountCard";
import { DisconnectVoiceAccountAlert } from "../../../../components/DisconnectVoiceAccountAlert";
import { useVoiceAccount } from "../../../../hooks/useVoiceAccount";
import { ReactComponent as CopyIcon } from "./assets/copy.svg";
import { ReactComponent as PhoneCallsIcon } from "./assets/voice.svg";
import { ReactComponent as RemoveIcon } from "./assets/remove.svg";
import { ReactComponent as PhoneIcon } from "./assets/phone.svg";

export const VoiceHeaderSection: React.FC = () => {
  const { t } = useTranslations();
  const { copyToClipboard } = useClipboard();
  const { account, isDisconnecting, isConnected } = useVoiceAccount();
  const [isDisconnectAlertOpen, setIsDisconnectAlertOpen] = useState(false);

  const phoneNumber = account?.phone_num ?? "";

  return (
    <>
      <CRMAccountCard
        icon={PhoneCallsIcon}
        title={t({
          id: "client-support-page.voice",
          defaultMessage: "Phone calls",
        })}
        description={
          isConnected
            ? t({
                id: "common.live",
                defaultMessage: "Live",
              })
            : t({
                id: "client-support-page.voice-is-currently-disabled",
                defaultMessage:
                  "Phone calls is currently disabled. Enable to go live",
              })
        }
        status={isConnected ? "enabled" : "disabled"}
        menuItems={
          isConnected
            ? [
                [
                  {
                    id: "disconnect-account",
                    label: t({
                      id: "client-support-page.disconnect-account",
                      defaultMessage: "Disconnect Account",
                    }),
                    icon: <RemoveIcon />,
                    onSelect: () => setIsDisconnectAlertOpen(true),
                    isDisabled: isDisconnecting,
                  },
                ],
              ]
            : undefined
        }
      >
        {phoneNumber && (
          <div className="flex w-full max-w-125 flex-col gap-4">
            <span className="font-secondary text-sm tracking-[0.14px] text-dark-800">
              {t({
                id: "client-support-page.associated-phone-number",
                defaultMessage: "Associated phone number:",
              })}
            </span>
            <div className="flex h-16 items-center gap-2.5 rounded-2xl border border-solid border-dark-200 bg-white px-4">
              <PhoneIcon />
              <span className="grow truncate font-secondary leading-[140%] font-medium tracking-[0.16px] text-dark">
                {phoneNumber}
              </span>
              <PlainButton
                className={cx("h-8 w-8", collapsedIconButtonClassName)}
                onClick={() => copyToClipboard(phoneNumber)}
              >
                <CopyIcon />
              </PlainButton>
            </div>
          </div>
        )}
      </CRMAccountCard>
      <DisconnectVoiceAccountAlert
        isOpen={isDisconnectAlertOpen}
        onRequestClose={() => setIsDisconnectAlertOpen(false)}
      />
    </>
  );
};
